import graphQLAdapter from "@/adapters/graphQL.adapter.js";
import OrderNote from "@/entities/orderNote.entity.js";

/**
 * Message Service Class
 *
 * @export
 * @class
 */
export default class {
  constructor () {
    // eslint-disable-next-line
    this.adapter = new graphQLAdapter();
    this.getOrderNotes = getOrderNotes.bind(this);
    this.createOrderNote = createOrderNote.bind(this);
  }
  /**
   * Get the list of messages
   *
   * @static
   * @returns {Promise<Object|null>} Promise object represents the list of messages
   */
  async list (option) {
    await this.adapter.init();
    const res = await this.getOrderNotes(option);
    return res.data.orderNotes.map(el => OrderNote.fromJson(el));
  }
  async create (option) {
    await this.adapter.init();
    return this.createOrderNote(option);
  }
}

function getOrderNotes (options = { orderId: null }) {
  const query = `query($orderId: ID!){
    orderNotes(orderId: $orderId) {
      id
      from {
        id
        name
        avatarImageUrl
      }
      order {
        id
        customer {
          name
        }
        client{
          clientGroups {
            name
          }
        }
      }
      body
      createdAt
    }
  }`;
  return this.adapter.query(query, options);
}

function createOrderNote (options = {}) {
  const mutation = `mutation ($fromUserId: String, $orderId: String, $body: String){
    orderNoteCreate(orderNote: { fromUserId: $fromUserId, orderId: $orderId, body: $body}) {
      id
      from {
        id
        name
        avatarImageUrl
      }
      order {
        id
      }
      body
      createdAt
    }
  }
  `;
  return this.adapter.mutation(mutation, options);
}
